import React from 'react'
import {useSelector} from 'react-redux'
import {BrandHeartIcon} from 'components/PriceWatch/components/BrandHeartIcon'
import {PriceWatchCTAWrapper} from 'components/PriceWatchCTAWrapper/PriceWatchCTAWrapper'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'
import {getAccommodationPageHotel} from 'modules/searchApi/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {PriceWatchBaseToggle} from '@vio/shared/src/priceWatch/components/PriceWatchBaseToggle'
import {useIsSaveFraming} from '@vio/shared/src/priceWatch/hooks/useIsSaveFraming'
import {myListMessages} from '@vio/shared/src/priceWatch/myListMessages'

import {useAccommodationTopOffers} from '../Offers/useAccommodationTopOffers'
import {BrandBellIcon} from './BrandBellIcon'
import {PriceWatchSkeleton} from './PriceWatchSkeleton'

export const PriceWatchCard = ({offersLength}: {offersLength: number}) => {
  const hotel = useSelector(getAccommodationPageHotel)

  const hotelId = useSelector(getAccommodationPageHotelId)
  const {hasAnyOffers, isComplete} = useAccommodationTopOffers({
    hotelId
  })

  const {isDesktopXs} = useDeviceLayout()
  const horizontalLayout = isDesktopXs && offersLength > 1
  const loading = !hasAnyOffers && !isComplete
  const saveFramingIsOn = useIsSaveFraming()

  if (loading) return <PriceWatchSkeleton />

  return (
    <Box
      display="flex"
      width="100%"
      flexDirection={horizontalLayout ? 'row' : 'column'}
      height="100%"
      gap={horizontalLayout ? 's600' : 's200'}
    >
      {saveFramingIsOn ? <BrandHeartIcon /> : <BrandBellIcon />}
      <Box
        display="flex"
        flexDirection="column"
        gap="s300"
        width="100%"
        height="100%"
        justifyContent="space-between"
      >
        <Box
          marginTop={horizontalLayout ? undefined : 's400'}
          display="flex"
          flexDirection="column"
          gap="s200"
          flexGrow={horizontalLayout ? '1' : undefined}
        >
          <Text variant="titleM">
            {saveFramingIsOn ? (
              <FormattedMessageWrapper
                {...myListMessages.susiSaveTitle}
                dataId="priceWatchPopUp.title"
              />
            ) : (
              <FormattedMessageWrapper
                id="priceWatchTitle"
                dataId="priceWatchPopUp.title"
                defaultMessage="Never miss a price drop"
              />
            )}
          </Text>

          <Text variant="bodyS" colorPath="content.neutral.secondary">
            {saveFramingIsOn ? (
              <FormattedMessageWrapper {...myListMessages.apCardDescription} />
            ) : (
              <FormattedMessageWrapper
                id="priceAlertOnboardingDescription"
                defaultMessage="We actively monitor prices in the background and will notify you when the prices change."
              />
            )}
          </Text>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          gap="s300"
        >
          <Text variant="titleS">
            {saveFramingIsOn ? (
              <FormattedMessageWrapper {...myListMessages.anchorCardTitle} />
            ) : (
              <FormattedMessageWrapper
                id="priceWatchCard.turnOnPriceAlerts"
                defaultMessage="Turn on price alerts"
              />
            )}
          </Text>
          <PriceWatchCTAWrapper
            hotel={hotel}
            searchIsCompleted={!loading}
            ctaComponent={PriceWatchBaseToggle}
            componentName="PriceWatchCard"
          />
        </Box>
      </Box>
    </Box>
  )
}
